// extracted by mini-css-extract-plugin
export var buttonContainer = "_7e-1";
export var fontSizeSelect = "_7e-3";
export var formatSelect = "_7e-2";
export var formats = "_7e-4";
export var hidden = "_7e-5";
export var icon = "_7e-6";
export var select = "_7e-0";